'use es6';

import PropTypes from 'prop-types';
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { IMG } from 'conversations-message-history/common-message-format/constants/fileAttachmentTypes';
import { displayName } from 'conversations-internal-schema/file-metadata/operators/displayName';
import { getExtension, getSize, getType, getUrl } from 'conversations-internal-schema/file-metadata/operators/fileMetadataGetters';
import FormattedSize from 'I18n/components/FormattedSize';
import { PureComponent } from 'react';
import styled from 'styled-components';
import UIFileAttachment from 'UIComponents/attachment/UIFileAttachment';
import UIImage from 'UIComponents/image/UIImage';
import UILink from 'UIComponents/link/UILink';
import UITruncateString from 'UIComponents/text/UITruncateString';
import ThemeContext from 'conversations-message-history/primary-message/provider/ThemeContext';
import { getTileBackgroundColor, getTileBorderColor } from 'conversations-message-history/attachments/operators/fileAttachmentThemeGetters';
import { getFileAttachmentTheme } from 'conversations-message-history/primary-message/operators/themeGetters';
import { usageTracker } from '../usage-tracker/usageTracker';
import { getUsageTrackingChannel } from '../usage-tracker/trackerChannelIdMapping';
import { jsx as _jsx } from "react/jsx-runtime";
export const FileAttachmentTileWrapper = styled.div.withConfig({
  displayName: "FileAttachmentTile__FileAttachmentTileWrapper",
  componentId: "sc-1bbaxnl-0"
})(["max-width:300px;"]);
const StyledFileAttachment = styled(UIFileAttachment).withConfig({
  displayName: "FileAttachmentTile__StyledFileAttachment",
  componentId: "sc-1bbaxnl-1"
})(["background-color:", ";"], ({
  backgroundColor
}) => backgroundColor || 'rgba(255, 255, 255, 0.5)');
class FileAttachmentTile extends PureComponent {
  render() {
    const {
      fileMetadata,
      genericChannelId
    } = this.props;
    const name = displayName(fileMetadata);
    const url = getUrl(fileMetadata);
    const size = getSize(fileMetadata);
    const type = getType(fileMetadata);
    const extension = getExtension(fileMetadata);
    const useImagePreview = type === IMG && extension !== 'svg';
    const handleClickAttachment = () => {
      usageTracker.track('click-attachment', {
        action: 'click attachment',
        channel: getUsageTrackingChannel(genericChannelId)
      });
    };
    return /*#__PURE__*/_jsx(FileAttachmentTileWrapper, {
      children: /*#__PURE__*/_jsx(UILink, {
        href: url,
        target: "_blank",
        use: "unstyled",
        onClick: handleClickAttachment,
        children: /*#__PURE__*/_jsx(StyledFileAttachment, {
          className: "m-y-2",
          backgroundColor: getTileBackgroundColor(getFileAttachmentTheme(this.context)),
          borderColor: getTileBorderColor(getFileAttachmentTheme(this.context)),
          fileName: /*#__PURE__*/_jsx(UITruncateString, {
            children: name
          }),
          fileInfo: /*#__PURE__*/_jsx(FormattedSize, {
            value: size
          }),
          size: "small",
          renderPreview: useImagePreview ? () => /*#__PURE__*/_jsx(UIImage, {
            alt: name,
            shape: "thumbnail",
            src: url
          }) : undefined
        })
      })
    });
  }
}
FileAttachmentTile.contextType = ThemeContext;
FileAttachmentTile.displayName = 'FileAttachmentTile';
FileAttachmentTile.propTypes = {
  fileMetadata: RecordPropType('FileMetadataRecord').isRequired,
  genericChannelId: PropTypes.number.isRequired
};
export default FileAttachmentTile;